/**
 * State handler
 * Mobx stores importer
 */

import { useStrict } from 'mobx';
// Import stores
import MediahubStore from 'stores/MediahubStore';
import ViewStore from 'stores/ViewStore';
import WallStore from 'stores/WallStore';

// Set strick mode for stores, so you can only change state through actions
useStrict(true);

// Export store variable
export const initializeStores = () => ({
  MediahubStore,
  WallStore,
  ViewStore,
});

export default initializeStores;



// WEBPACK FOOTER //
// ./src/stores.js